var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-icon", { attrs: { color: "grey", small: "" } }, [
    _vm._v(" mdi-translate "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }